import React, { useEffect } from "react";

import "./VoiceCommands.css";
import { COMMANDS } from "../../data";

const VoiceCommands = ({ command }) => {
  useEffect(() => {
    if (command) {
      const foundCommand = COMMANDS.find((c) =>
        command.toLowerCase().includes(c.command.toLowerCase())
      );
      if (foundCommand) {
        foundCommand.action();
      }
    }
  }, [command]);

  const renderCommand = (commandValue, index) => {
    return (
      <span
        key={index}
        className={
          command.toLowerCase() === commandValue.command.toLowerCase()
            ? "focused-command"
            : "command"
        }
      >
        {commandValue.command}
      </span>
    );
  };

  return (
    <div className="commands-window">
      <div className="commands-container">
        <span className="commands-container-title">Try saying:</span>
        <div className="commands">{COMMANDS.map(renderCommand)}</div>
      </div>
    </div>
  );
};

export default VoiceCommands;
